<template>
  <div class="text-body text-black-2 inline-flex items-center gap-1">
    <span v-if="!metadata || metadata === '{}'">-</span>
    <div v-else class="flex flex-col">
      <template v-for="(item, index) in metadataObject" :key="index">
        <div>"{{ index }}": "{{ item }}"</div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { parseJsonSilently } from "@/utils/JsonUtls";
import { computed } from "vue";

const props = defineProps({ metadata: { type: String, default: "" } });
const metadataObject = computed(() => parseJsonSilently(props.metadata));
</script>
